import Blue from '~/core'

new Blue({
  name: 'Form Validate',
  selector: '.form--validate',
  setup(form) {
    this.$validate(form)
  },
})

new Blue({
  name: 'Form Input Validation',
  selector: '.blue-form form',
  setup(form) {
    const hasInput = form.querySelector('[id*="_USPhone_Value"]')

    if (hasInput) {
      this.$addEvents(hasInput, 'input', (event) => {
        const hasError = hasInput.parentNode.querySelector('.field-validation-error')
        if (hasError) {
          hasError.remove()
        }
        let x = event.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
        event.target.value = !x[2] ? x[1] : '(' + x[1] + ')' + x[2] + (x[3] ? '-' + x[3] : '')
      })

      // this.$addEvents(form, 'submit', (event) => {
      //   let isValid = true

      //   if (!isValidPhoneNumber(hasInput.value)) {
      //     const hasError = hasInput.parentNode.querySelector('.field-validation-error')
      //     if (hasError) {
      //       hasError.remove()
      //     }
      //     showError(hasInput, 'Please enter a valid phone number in the format (###)###-####')
      //     isValid = false
      //   }

      //   if (typeof grecaptcha !== "undefined") {
      //     let recaptchaResponse = grecaptcha.getResponse();

      //     if (recaptchaResponse.length === 0) {
      //       showError(event.target, 'Please fill out the captcha before submitting')
      //       isValid = false
      //     }
      //   }

      //   if (!isValid) {
      //     event.preventDefault()
      //   }
      //// })
    }
  },
})
